// One expiry path for JSON, uploads, authenticated fetches and the idle clock.
export const ADMIN_SESSION_EXPIRED = 'plateos:session-expired';
export const isAdminSessionPath = path => /^\/(admin|superadmin|app|billing|dashboard)(\/|$)/.test(path);
export const adminLoginPath = path => /^\/superadmin(\/|$)/.test(path) ? '/superadmin/login' : '/admin';
// Let the login page verify incoming credentials before expiring an old session.
export const isAdminLoginHandoff = (path, search) => {
  if (!/^\/admin\/?$/.test(path)) return false;
  const params = new URLSearchParams(search);
  return Boolean(params.get('sso_token') || (params.get('token') && params.get('type') === 'magic'));
};
export const storedAdminToken = () => {
  try { return localStorage.getItem('plateos_token') || localStorage.getItem('token'); }
  catch { return null; }
};

export const tokenExpiry = token => {
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(payload.padEnd(Math.ceil(payload.length / 4) * 4, '=')));
    return typeof exp === 'number' && Number.isFinite(exp) ? exp * 1000 : null;
  } catch { return null; } // The server remains the authentication authority.
};

let redirecting = false;
export function expireAdminSession(expectedToken) {
  if (typeof window === 'undefined' || !isAdminSessionPath(window.location.pathname)) return false;
  if (isAdminLoginHandoff(window.location.pathname, window.location.search)) return false;
  const current = storedAdminToken();
  // An unauthenticated 401 is not evidence that a session expired.
  if (!current && !expectedToken) return false;
  // A late response from an old request must not sign out a newer login.
  if (expectedToken !== undefined && current && current !== expectedToken) return false;
  if (redirecting || window.location.pathname === '/superadmin/login') return false;
  if (!current && new URLSearchParams(window.location.search).get('session') === 'expired') return false;
  redirecting = true;
  for (const key of ['plateos_token', 'plateos_user', 'token', 'user', 'tenant_id']) {
    try { localStorage.removeItem(key); } catch { /* restricted storage */ }
  }
  try { sessionStorage.removeItem('plateos_show_setup_tour'); } catch { /* restricted storage */ }
  window.dispatchEvent(new Event(ADMIN_SESSION_EXPIRED));
  // A full replacement also clears mounted page caches and stops their polling.
  // /admin is the existing tenant login door on production AND local hosts.
  window.location.replace(`${adminLoginPath(window.location.pathname)}?session=expired`);
  return true;
}
